import React from "react";
import "../assets/styles/scss/Work.scss";
import {
  Background,
  Body,
} from "../assets/styles/styled-components/GlobalStyles";
import BackgroundImage from "../assets/images/meplug/meplug_bg.jpg";
import { Link } from "react-router-dom";

export default function Work() {
  return (
    <Link to="/projects/meplug">
      <div style={{ overflow: "hidden" }}>
        <Background bg={BackgroundImage} />
        <Body isCollapsed={true} h={"0px"}>
          <div className="work-box">
            <p>June 2022 - August 2022</p>
            <h1>MEPLUG</h1>
            <p>Website Mobile IoT Innovation Enterprise</p>
          </div>
        </Body>
      </div>
    </Link>
  );
}
